import React from 'react';
import { observer } from 'mobx-react';
import { i18n } from 'core/localization';
import { AntButton } from 'controls/react/ant/antButton';
import { Toolbar, ToolbarItemPosition } from 'controls/react/layout/toolbar';
import { AuthenticationFormFooterProps } from 'areas/administration/authentication/types';

export const AuthenticationFormFooter = observer(({ store, extra }: AuthenticationFormFooterProps) => (
	<Toolbar>
		{store.oauthValidation?.started && !store.readOnly && (
			<AntButton
				type={'primary'}
				position={ToolbarItemPosition.BEFORE_TITLE}
				disabled={!store.oauthValidation.canValidate}
				loading={store.oauthValidation.validating}
				onClick={store.validateOAuth}
			>
				{i18n('Validate')}
			</AntButton>
		)}
		{!store.readOnly && <extra.OkBtn position={ToolbarItemPosition.AT_THE_END} />}
		<extra.CancelBtn position={ToolbarItemPosition.AT_THE_END} />
	</Toolbar>
));
